import { Pipe, PipeTransform } from '@angular/core';

import { TrendDirection } from './models/oa.model';

@Pipe({
    name: 'trendArrow',
})
export class TrendArrow implements PipeTransform {
    transform(type: TrendDirection): [string, string] {
        switch (type) {
            case TrendDirection.UPGOOD:
                return ['legacy:cmps-cdk-fill-good-100', 'chevron-up'];
            case TrendDirection.UPBAD:
                return ['cmps-cdk-fill-red-100', 'chevron-up'];
            case TrendDirection.DOWNGOOD:
                return ['legacy:cmps-cdk-fill-good-100', 'chevron-down'];
            case TrendDirection.DOWNBAD:
                return ['cmps-cdk-fill-red-100', 'chevron-down'];
            case TrendDirection.NOTREND:
                return ['cmps-cdk-fill-grey-300', ''];
            default:
                return ['', ''];
        }
    }
}
